/** Client routes (nested under `/app` in App.tsx). */
export function accountDetailPath(accountId: string): string {
  return `/app/accounts/${accountId}`;
}
